import type { FeatureManifest } from '@/app/registry';
import { CONTEXTS, lazyView } from '@/app/registry';
import { requireFeatureEnabled } from '@/app/router/guards/require-feature-enabled';
import { useFeatureFlagsStore } from '@/app/stores/use-feature-flags-store';
import { subscriptionRoutes } from './routes';
import { SUBSCRIPTIONS_FLAG } from './constants';

/**
 * L'abonnement Skill-Up (SAAS-1311), dans la feature `purchases` parce qu'il
 * réutilise son checkout. Un manifest à part pour porter son drapeau : celui de
 * la Boutique n'en a pas.
 *
 * Pas d'entrée de menu à lui : l'abonnement se vend dans la Boutique, et
 * « Mon abonnement » s'ouvre depuis la Boutique et « Mes achats ». Ces deux
 * liens s'allument sur ses contextes (cf. `manifest.ts`).
 *
 * Drapeau coupé, **rien n'est visible** : `enabledWhen` retire la vue, la
 * Boutique et « Mes achats » cachent ce qui y mène, et la garde renvoie une URL
 * tapée à la main vers l'accueil (`enabledWhen` ne protège pas les routes,
 * cf. `requireFeatureEnabled`).
 *
 * Le drapeau de la garde est lu au chargement du module, comme pour le
 * parrainage : un `setFlag` en console demande un rechargement de la page.
 */
const SUBSCRIPTIONS_ENABLED = useFeatureFlagsStore.getState().flags[SUBSCRIPTIONS_FLAG] === true;

const SUBSCRIPTION_CONTEXTS = [
  CONTEXTS.SUBSCRIPTION,
  CONTEXTS.SUBSCRIPTION_SUCCESS,
  CONTEXTS.SUBSCRIPTION_CANCEL,
] as const;

export const subscriptionManifest: FeatureManifest = {
  id: 'subscription',
  contexts: SUBSCRIPTION_CONTEXTS,

  routes: [
    {
      zone: 'authenticated',
      routes: subscriptionRoutes,
      errorFallbackLabel: 'Abonnement',
      guard: requireFeatureEnabled(SUBSCRIPTIONS_ENABLED),
    },
  ],

  centerView: {
    [CONTEXTS.SUBSCRIPTION]: lazyView(() => import('./views/SubscriptionView'), 'SubscriptionView'),
    [CONTEXTS.SUBSCRIPTION_SUCCESS]: lazyView(
      () => import('./views/SubscriptionView'),
      'SubscriptionSuccessView',
    ),
    [CONTEXTS.SUBSCRIPTION_CANCEL]: lazyView(
      () => import('./views/SubscriptionView'),
      'SubscriptionCancelView',
    ),
  },

  enabledWhen: { featureFlag: SUBSCRIPTIONS_FLAG },
};
